/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ completed: NonNullable<unknown>, required: NonNullable<unknown> }} Socialmatchnotready3Inputs */



/**
* | output |
* | --- |
* | "Chat with Luni a bit more to unlock Social Match. Readiness: {completed} out of {required}" |
*
* @param {Socialmatchnotready3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const socialmatchnotready3 = /** @type {((inputs: Socialmatchnotready3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Socialmatchnotready3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Chat with Luni a bit more to unlock Social Match. Readiness: ${i?.completed} out of ${i?.required}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Habla un poco más con Luni para desbloquear Social Match. Preparación: ${i?.completed} de ${i?.required}`)
	return /** @type {LocalizedString} */ (`Пообщайся ещё немного с Луни, и Social Мэтч станет доступен. Готовность: ${i?.completed} из ${i?.required}`)
});
export { socialmatchnotready3 as "socialMatchNotReady" }